import { render, staticRenderFns } from "./materialDetails.vue?vue&type=template&id=230da04f"
import script from "./materialDetails.vue?vue&type=script&lang=js"
export * from "./materialDetails.vue?vue&type=script&lang=js"
import style0 from "./materialDetails.vue?vue&type=style&index=0&id=230da04f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports